// removed by extract-text-webpack-plugin
module.exports = {"Oyster":"#C0C5C9","Bluecheese":"#615CFF","header":"Gc5b739 G3c3c24","headerTitle":"G97c9c0","headerCta":"G02007e","currentValue":"Gb4af04"};